<!-- ============ HERO ============ -->
  <section class="ao-hero">
    <div class="ao-wrap ao-hero-grid">
      <div class="ao-hero-content ao-reveal">
        <span class="ao-eyebrow"><span class="dot"></span> Admissions Open 2026–2027</span>
        <h1>Unlock Your Child's <span>11+ Potential</span></h1>
        <p class="ao-hero-tagline">
          Take Sehyog Academy's 11+ Assessment Test, discover exactly where your child stands, and win scholarships — with expert mock tests and personalised feedback every step of the way.
        </p>
        <div class="ao-btn-row">
          <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="ao-btn-primary">Apply for Admission</a>
          <a [routerLink]="['/freedemo']"  class="ao-btn-outline">Book a Free Demo <i class="ti ti-arrow-right"></i></a>
        </div>
        <div class="ao-stat-row">
          <div class="ao-stat-chip">
            <span class="ic"><i class="ti ti-users"></i></span>
            <span><span class="num">10000+</span><br><span class="lbl">Students Guided</span></span>
          </div>
          <div class="ao-stat-chip">
            <span class="ic"><i class="ti ti-medal"></i></span>
            <span><span class="num">3 Tiers</span><br><span class="lbl">Scholarship Rewards</span></span>
          </div>
          <div class="ao-stat-chip">
            <span class="ic"><i class="ti ti-chart-bar"></i></span>
            <span><span class="num">100%</span><br><span class="lbl">Personalised Feedback</span></span>
          </div>
        </div>
      </div>
      <div class="ao-hero-image ao-reveal">
        <div class="frame">
          <img src="https://images.pexels.com/photos/5212326/pexels-photo-5212326.jpeg" alt="Students preparing for 11+ admission at Sehyog Academy">
        </div>
        <div class="ao-badge-float">
          <span class="ic"><i class="ti ti-certificate"></i></span>
          <span>
            <span class="t1">Trusted by 10K+</span><br>
            <span class="t2">Parents &amp; Students</span>
          </span>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ COURSES ============ -->
  <section class="ao-section">
    <div class="ao-wrap">
      <div class="ao-section-head">
        <span class="bar"></span>
        <span class="label">Our Courses</span>
      </div>
      <h2 class="ao-title">Pick the Path That Fits Your Child</h2>
      <p class="ao-sub">From full 11+ admission preparation to intensive summer revision — choose the programme that matches your timeline and goals.</p>

      <div class="ao-course-grid">
        <div class="ao-course-card ao-reveal">
          <div class="inner">
            <div class="ao-course-info">
              <span class="ao-course-tag">11+ Admission</span>
              <h3>11+ Admission Preparation</h3>
              <p class="desc">Take the Assessment Test and win scholarships based on your child's rank — full support from test to CAF submission.</p>
              <ul class="ao-rank-list">
                <li><span class="medal-ic medal-1"><i class="ti ti-award"></i></span> 1st Rank — 75% OFF</li>
                <li><span class="medal-ic medal-2"><i class="ti ti-award"></i></span> 2nd Rank — 50% OFF</li>
                <li><span class="medal-ic medal-3"><i class="ti ti-award"></i></span> 3rd Rank — 25% OFF</li>
              </ul>
              <a href="https://zfrmz.in/CXWHedw5dEnsTL7d361m" class="ao-course-cta gold">Apply Now <i class="ti ti-arrow-right"></i></a>
            </div>
            <div class="ao-course-image">
              <img src="https://images.pexels.com/photos/35745334/pexels-photo-35745334.jpeg" alt="Student taking 11+ assessment test">
            </div>
          </div>
        </div>

        <div class="ao-course-card ao-reveal">
          <div class="inner">
            <div class="ao-course-info">
              <span class="ao-course-tag">Summer Intensive</span>
              <h3>11+ Summer Bootcamp</h3>
              <p class="desc">Subject-specific revision across four 11+ subjects - 8 focused days each, built around the exam boards that matter.</p>
              <a [routerLink]="['/11plus-summer-bootcamp']" class="ao-course-cta">Book Now <i class="ti ti-arrow-right"></i></a>
            </div>
            <div class="ao-course-image">
              <img src="https://images.pexels.com/photos/8457719/pexels-photo-8457719.jpeg" alt="Students in summer intensive revision course">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ WHY CHOOSE US ============ -->
  <section class="ao-section alt">
    <div class="ao-wrap">
      <div class="ao-section-head">
        <span class="bar"></span>
        <span class="label">Why Sehyog Academy</span>
      </div>
      <h2 class="ao-title">Everything Your Child Needs to Succeed</h2>
      <p class="ao-sub">We combine expert teaching, a proven curriculum, and detailed feedback so every student walks into exam day prepared and confident.</p>

      <div class="ao-feature-grid">
        <div class="ao-feature-card ao-reveal">
          <span class="ic"><i class="ti ti-school"></i></span>
          <h3>Best Teachers</h3>
          <p>Good tutors teach you, but the best tutors prepare you for the future — shaping skills, not just knowledge.</p>
        </div>
        <div class="ao-feature-card ao-reveal">
          <span class="ic"><i class="ti ti-books"></i></span>
          <h3>Best Curriculum</h3>
          <p>A structured, exam-focused curriculum built from years of 11+ experience across Sunamganj and beyond.</p>
        </div>
        <div class="ao-feature-card ao-reveal">
          <span class="ic"><i class="ti ti-report-analytics"></i></span>
          <h3>Assessment &amp; Feedback</h3>
          <p>Every mock test comes with a detailed readiness report — so you know exactly what to work on next.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ PROCESS / HOW IT WORKS ============ -->
  <section class="ao-section">
    <div class="ao-wrap">
      <div class="ao-section-head">
        <span class="bar"></span>
        <span class="label">How It Works</span>
      </div>
      <h2 class="ao-title">From Mock Test to Admission Offer</h2>
      <p class="ao-sub">A clear, guided journey — the same one that's helped hundreds of families navigate their 11+ admission with confidence.</p>

      <div class="ao-process-grid">
        <div class="ao-process-step ao-reveal">
          <div class="num">01</div>
          <h4>Take the Mock Test</h4>
          <p>Sit a full 11+ assessment test under realistic exam conditions.</p>
        </div>
        <div class="ao-process-step ao-reveal">
          <div class="num">02</div>
          <h4>Get Your Result Analysis</h4>
          <p>Receive a detailed report showing exactly where your child is strong and where to improve.</p>
        </div>
        <div class="ao-process-step ao-reveal">
          <div class="num">03</div>
          <h4>Personalised Feedback</h4>
          <p>Work through targeted revision plans and topic-wise tests built around the results.</p>
        </div>
        <div class="ao-process-step ao-reveal">
          <div class="num">04</div>
          <h4>CAF &amp; School Guidance</h4>
          <p>Get expert help submitting the CAF form and choosing the right school preferences.</p>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ TESTIMONIALS ============ -->
  <section class="ao-testimonial-section">
    <div class="ao-wrap">
      <div class="ao-testimonial-head">
        <div class="ao-section-head">
          <span class="bar"></span>
          <span class="label">Testimonials</span>
        </div>
        <h2>What <span>Parents</span> Say About Us</h2>
      </div>

      <div class="ao-t-grid">
        <div class="ao-t-card ao-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>My son did Sehyog Mock Test — it's very helpful to know which areas he's lacking. The result analysis gives clear understanding of what to improve, and the team even guided us on submitting the CAF form with school preferences. Thank you Sehyog team!</p>
          <div class="ao-t-foot">
            <span class="ao-avatar">JR</span>
            <span><span class="ao-t-name">Jaya Rani</span><br><span class="ao-t-role">Parent</span></span>
          </div>
        </div>
        <div class="ao-t-card ao-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>My son got admission in KEGS. Thank you so much Sehyog! Your mocks were awesome, and he learnt so much because of them. If he hadn't done these mocks, he may not have got in — thank you again, Sehyog family!</p>
          <div class="ao-t-foot">
            <span class="ao-avatar">AD</span>
            <span><span class="ao-t-name">Asima Dar</span><br><span class="ao-t-role">Parent</span></span>
          </div>
        </div>
        <div class="ao-t-card ao-reveal">
          <span class="quote-ic"><i class="ti ti-quote"></i></span>
          <p>The detailed weekly results told us exactly which area to work on, and the topic-wise tests were a great form of revision. The whole team's help was fabulous — it helped my son secure a place at his school of choice.</p>
          <div class="ao-t-foot">
            <span class="ao-avatar">MD</span>
            <span><span class="ao-t-name">Mini Dagar</span><br><span class="ao-t-role">Parent</span></span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ============ CONTACT ============ -->
  <section class="ao-section">
    <div class="ao-wrap">
      <div class="ao-contact ao-reveal">
        <div class="ao-contact-info">
          <h2><span>Contact</span> Us</h2>
          <p class="sub">Have questions about admission? We're here to help.</p>
          <div class="ao-contact-list">
            <div class="row"><span class="ic"><i class="ti ti-phone"></i></span> (0)2039808244</div>
            <div class="row"><span class="ic"><i class="ti ti-mail"></i></span> support@sehyog.co.uk</div>
            <div class="row"><span class="ic"><i class="ti ti-brand-whatsapp"></i></span> +44 7464772331</div>
          </div>
        </div>
        <div class="ao-contact-image">
          <img src="https://images.unsplash.com/photo-1740635341299-3b8e3490f546?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTh8fHNjaG9vbHxlbnwwfHwwfHx8Mg%3D%3D" alt="Sehyog Academy customer support">
        </div>
      </div>
    </div>
  </section>